const oMeta = require('meta.json');
// Constante del sistema que indica la version del mismo
export const APP_VERSION = `v 0.1 ${oMeta.date}`;
// Constantes del sistema que seran importadas en los demas archivos
export const Constants = {
    API_URL: process.env.REACT_APP_API_URL
}
// Formatos de fechas
export const DATES_FORMATS = {
    DEFAULT: 'DD/MM/YYYY',
    MYSQL: 'YYYY/MM/DD',
    MYSQL_SERVER: 'YYYY-MM-DD',
    MYSQL_SERVER_TIMESTAMPS_DEFAULT_24_HOURS: 'YYYY-MM-DD H:mm:ss',
    TIMESTAMPS_DEFAULT: 'YYYY/MM/DD H:mm:ss',
    TIMESTAMPS_DEFAULT_24_HOURS: 'YYYY/MM/DD H:mm:ss',
    TIMESTAMPS_WITHOUT_SECONDS_24_HOURS: 'YYYY/MM/DD H:mm',
    TIMESTAMPS_WITHOUT_SECONDS_24_HOURS_REVERSE: 'DD/MM/YYYY H:mm',
    TIME_DEFAULT: 'HH:mm',
    // Constantes de unidades para plugin y manejo de fechas
    CONSTANTS: {
        UNITS: {
            DAYS: 'days',
            WEEKS: 'week',
            MONTHS: 'month',
            YEARS: 'year',
        }
    }
}
// Forma de identificar el tipo de acción en lugares compartidos para los distintos tipos de datos
export const CONSTANT_TYPE_PATERNITY_STUDIES = 1;
export const CONSTANT_TYPE_CLINICAL_ANALYSIS = 2;
export const CONSTANT_TYPE_PROSPECTS = 3;

export const CONSTANT_SAMPLE_TYPE_FOR_PATERNITY_STUDY = "E";
export const CONSTANT_SAMPLE_TYPE_FOR_CLINICAL_ANALYSIS = "A";

export const CONSTANT_AGENDA_STATUS_CANCELED_ID = 4;

/**
 * Expresión regular para comprobar que la contraseña contenga todo lo especificado y ademas tenga 
 *  su largo minímo, a continuación se explica su composición
 *
 * ? [A-Za-z0-9@$!%*?&#] - Especifica los elementos que pueden contener la cadena (A-Z significa todas las mayúsculas, a-z todas las minusculas, 0-9 números y simbolos de forma individual)
 * ? {8,} - Largo de la cadena, su uso es siempre {1, 15} que significa de 1 a 15 caracteres, en nuestro caso significa al menos 8
 * ? (?=.*[a-z]) - Especifica que debe contener al menos una minuscula
 * ? (?=.*[A-Z]) - Especifica que debe contener al menos una mayuscula
 * ? (?=.*[0-9]) - Especifica que debe contener al menos un número
 * ? (?=.*[@$!%*?&#]) - Especifica que debe contener al menos un simbolo de los que se especifican dentro de los parentesís rectos
 * ? /^ - Apertura de la expresión regular
 * ? $/ - Cierre de la expresión regular
 * 
 */
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$!%*?&#])[A-Za-z0-9@$!%*?&#]{8,}$/;

export const DOCUMENT_TYPE_ID_CI_URUGUAY = 1;